export default "__VITE_PUBLIC_ASSET__6185fe3f__"